module.exports = __webpack_public_path__ + "img/39.f3e76fcb.jpg";